import type { EFrom } from 'reactApp/components/SharingWindow/Sharing.types';
import type { PublishItem } from 'reactApp/modules/modifying/modifying.types';

export const enum SHARING_VARIANT {
    default = 'default',
    tabs = 'tabs',
    redesign = 'redesign',
    biz = 'biz',
}

export interface IProps {
    item?: PublishItem;
    from: EFrom;
    isPhone?: boolean;
    isReadOnly: boolean;
    isEmbeded?: boolean;
    variant?: SHARING_VARIANT;
}
